var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-sticker-card"},[_c('div',{staticClass:"c-sticker-card__img-wrapper u-margin-bottom-small"},[(_vm.showSticker)?_c('nuxt-img',_vm._b({},'nuxt-img',_vm.$getImgOptions(_vm.sticker, {
        format: 'webp',
        width: 100
      }),false)):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"c-sticker-card__title t-heading-6 u-margin-bottom-small"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),(_vm.description)?[_c('p',{staticClass:"c-sticker-card__description t-paragraph",domProps:{"innerHTML":_vm._s(_vm.description)}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }